import React from 'react';
import { Switch, Route } from 'react-router-dom';
import Signup from './containers/Auth/Signup/Signup';
import Login from './containers/Auth/Login/Login';
import Home from './containers/Home/Home'
import DashBoard from './containers/Dashboard/Dashboard';
import ClientEdit from './containers/Dashboard/DashAdmin/ClientEdit/ClientEdit';
import ClientDocs from './containers/Dashboard/DashAdmin/ClientDocs/ClientDocs';
import ClientPreview from './containers/Dashboard/DashAdmin/ClientPreview/ClientPreview';


export default (props) => {

  return(
    <Switch>
      <Route exact path='/' component={Home}/>
      <Route exact path='/signup' component={Signup}/>
      <Route exact path='/login' component={Login}/>
      <Route exact path="/dashboard" component={DashBoard}/>
      <Route exact path="/client-edit/:id" component={ClientEdit}/>
      <Route exact path="/reports-upload/:id" component={ClientDocs}/>
      <Route exact path="/preview/:id" component={ClientPreview}/>
    </Switch>
  )
};
